<template>
  <div>
    <link itemprop="url" rel="stylesheet" href="css/search.css"/>
    <section>
      <HeaderOfPage
      :bgSrc          = "'search-banner.jpg'"
      :titleOfPage    = "'نتائج البحث'"
      :theDiscription = "'موقع أجـــازة بــوك هو بوابتك المميزة للسفر في أي مكان داخل أو خارج جمهورية مصر العربية لو حابب تسافر وتتعرف علي كل أماكن العالم السياحية ، وتستمتع بكل شبر داخل وخارج مصر وتعيش المغامرة مع اصحابك وتتفسح مع عيلتك، تقدر تتصفح أجـــازة بــوك وتختار عايز تسافر فين'"
      />
    </section>
    <section class="pages-container search-page">
      <SearchContent/>
    </section>
  </div>
</template>
<script type="text/javascript">
import HeaderOfPage    from '../global/HeaderOfPage'
import SearchContent   from './SearchContent'
  export default {
    name:'Search',
    components: {
      HeaderOfPage,
      SearchContent
    },
  }
</script>
